<template>
  <div>
      <video  v-if="type==74" style="width: 500px; height: 300px;background-color: black;" :src="tokenUrl" controls></video>
      <a v-if="type==71" :href="url1 + url" target="_black" >{{msg}}</a>
      <a v-if="type==713" :href="url" target="_black" >{{msg}}</a>

      <!-- <a v-if="type==712" :href="tokenUrl" target="_black" >{{msg}}</a> -->
      <a v-if="type==712" @click="downName(url,msg)" >{{msg}}</a>

       <el-image v-if="type==72" :src="tokenUrl"></el-image>

  </div>
</template>

<script>
import {getTokenUrl} from '@/api/uploading'
import {getFormal} from "@/utils/toos";
export default {
    props:["url",'type','msg'],
   data(){
       return{
          tokenUrl:'',
          url1: "https://view.officeapps.live.com/op/view.aspx?src=",
       }
   },
   mounted(){
       console.log('skjkasjkjal1',this.url,this.type );
    //    getTokenUrl(this.url).then(res=>{
    //        console.log('加密过的地址',res);
    //        this.tokenUrl = res
    //    })

   },
   methods:{
       downName(filePath,fileName){
        //    console.log('filePath',filePath,fileName);
    // window.open(`http://192.168.2.34:8080/support/download/download?filePath=${filePath}&fileName=${fileName}`)
    window.open(`${getFormal()}/support/download/downloadencoder?filePath=${filePath}&fileName=${fileName}`)

}
   }
}
</script>

<style scoped>
a {
    color: #409eff;
    text-decoration: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/videoUpy.vue